(function () {
  const STORAGE_KEY = 'nvz_bio_v1';
  const TTL_DAYS = 30;

  function init(root) {
    const scope = (root || document).querySelector('[data-supp-bio]');
    if (!scope || scope.dataset.bioInit === '1') return;
    scope.dataset.bioInit = '1';

    const reusePanel = scope.querySelector('[data-supp-bio-reuse]');
    const formPanel = scope.querySelector('[data-supp-bio-form]');
    const continueBtn = scope.querySelector('[data-supp-bio-continue]');
    const redirectUrl = scope.dataset.redirectUrl || '/pages/quiz-step';

    const cached = readCache();
    if (cached && reusePanel && formPanel) {
      fillSummary(reusePanel, cached);
      reusePanel.hidden = false;
      formPanel.hidden = true;
    }

    const useBtn = scope.querySelector('[data-supp-bio-reuse-use]');
    if (useBtn) useBtn.addEventListener('click', function () {
      const saved = readCache();
      if (saved) writeCache(saved);
      window.location.href = appendAutostart(redirectUrl);
    });

    const newBtn = scope.querySelector('[data-supp-bio-reuse-new]');
    if (newBtn) newBtn.addEventListener('click', function () {
      if (reusePanel) reusePanel.hidden = true;
      if (formPanel) formPanel.hidden = false;
      scope.querySelectorAll('[data-supp-bio-input]').forEach(function (i) { i.checked = false; });
      scope.querySelectorAll('[data-supp-bio-field]').forEach(function (g) {
        g.classList.remove('is-invalid');
      });
    });

    if (continueBtn) continueBtn.addEventListener('click', function () {
      const current = readSelected(scope);
      const missing = firstMissing(scope, current);
      if (missing) {
        missing.classList.add('is-invalid');
        const firstInput = missing.querySelector('input');
        if (firstInput) firstInput.focus({ preventScroll: true });
        missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      writeCache(current);
      window.location.href = appendAutostart(redirectUrl);
    });

    scope.querySelectorAll('[data-supp-bio-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        const fieldset = input.closest('[data-supp-bio-field]');
        if (fieldset) fieldset.classList.remove('is-invalid');
      });
    });
  }

  function readSelected(scope) {
    const out = { age: '', sex: '', activity: '' };
    scope.querySelectorAll('[data-supp-bio-field]').forEach(function (group) {
      const field = group.dataset.suppBioField;
      const picked = group.querySelector('input:checked');
      if (picked && field) out[field] = picked.value;
    });
    return out;
  }

  function firstMissing(scope, current) {
    const groups = scope.querySelectorAll('[data-supp-bio-field]');
    for (let i = 0; i < groups.length; i++) {
      const field = groups[i].dataset.suppBioField;
      if (field && !current[field]) return groups[i];
    }
    return null;
  }

  function fillSummary(panel, data) {
    const entries = {
      age: data.age,
      sex: data.sex === 'f' ? 'Female' : (data.sex === 'm' ? 'Male' : ''),
      activity: capitalize(data.activity)
    };
    Object.keys(entries).forEach(function (key) {
      const el = panel.querySelector('[data-supp-bio-summary="' + key + '"]');
      if (el) el.textContent = entries[key];
    });
  }

  function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  function appendAutostart(url) {
    if (!url) return '/pages/quiz-step?autostart=1';
    const separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'autostart=1';
  }

  function readCache() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      const ttlMs = TTL_DAYS * 24 * 60 * 60 * 1000;
      if (!parsed.savedAt || Date.now() - parsed.savedAt > ttlMs) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      if (!parsed.age || !parsed.sex || !parsed.activity) return null;
      return parsed;
    } catch (e) { return null; }
  }

  function writeCache(bio) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        age: bio.age,
        sex: bio.sex,
        activity: bio.activity,
        savedAt: Date.now()
      }));
    } catch (e) { /* silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
